import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const offerItems = [{
  title: 'Libro Principal: Código Hormonal 40+',
  description: 'Tu mapa paso a paso',
  value: 99
}, {
  title: 'Bonus 1: Protocolo Anti-Cortisol',
  description: 'Duerme y desinflama',
  value: 77
}, {
  title: 'Bonus 2: Socialite Protocole',
  description: 'Lo que realmente funciona a partir de los 40',
  value: 67
}, {
  title: 'Bonus 3: Recetas Express Hormonales',
  description: 'Para agendas ocupadas',
  value: 47
}];
export function Offer() {
  return <section className="bg-forest py-20 md:py-32" data-id="element-113">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-115">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-white mb-6 text-center" data-id="element-116">
            CÓDIGO HORMONAL 40+
          </h2>
          <p className="text-xl md:text-2xl text-warm-white/95 text-center mb-16" data-id="element-117">
            El sistema definitivo para la mujer moderna que no tiene tiempo para
            dietas pero se niega a conformarse con el declive.
          </p>

          <div className="bg-warm-white rounded-lg p-8 md:p-12 shadow-2xl" data-id="element-118">
            <div className="space-y-5 mb-10" data-id="element-119">
              {offerItems.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start gap-4 p-5 md:p-6 bg-white rounded-xl shadow-[0_10px_30px_-5px_rgba(45,74,62,0.15),0_4px_10px_-3px_rgba(0,0,0,0.05)] border border-charcoal/5" data-id="element-120">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gold/10 flex-shrink-0" data-id="element-121">
                    <CheckIcon className="w-5 h-5 text-gold" data-id="element-122" />
                  </div>
                  <div className="flex-1" data-id="element-123">
                    <h3 className="text-lg md:text-xl font-semibold text-charcoal mb-1" data-id="element-124">
                      {item.title}
                    </h3>
                    <p className="text-charcoal/60 mb-2" data-id="element-125">{item.description}</p>
                    <p className="text-charcoal/40 line-through text-sm" data-id="element-126">
                      Valor: ${item.value}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            <div className="border-t-2 border-gold pt-8" data-id="element-127">
              <div className="flex justify-between items-center mb-4" data-id="element-128">
                <span className="text-lg md:text-xl text-charcoal/70 font-medium" data-id="element-129">
                  Valor Total:
                </span>
                <span className="text-lg md:text-xl text-charcoal/40 line-through" data-id="element-130">
                  $223
                </span>
              </div>

              <div className="flex justify-between items-center mb-6" data-id="element-131">
                <span className="text-lg md:text-xl text-charcoal/70 font-medium" data-id="element-132">
                  Precio Normal:
                </span>
                <span className="text-2xl md:text-3xl text-charcoal/50 line-through font-serif" data-id="element-133">
                  $27
                </span>
              </div>

              <div className="relative bg-forest rounded-lg p-6 md:p-8 mb-8 overflow-hidden" data-id="element-134">
                <div className="absolute -top-3 -right-3 bg-gold text-charcoal text-xs md:text-sm font-bold px-4 py-2 rounded-full shadow-lg rotate-3" data-id="element-135">
                  OFERTA ESPECIAL
                </div>

                <p className="text-warm-white/90 text-sm md:text-base uppercase tracking-wider mb-2 font-semibold" data-id="element-136">
                  Solo Hoy Para Ti:
                </p>

                <div className="flex items-baseline gap-3 mb-3" data-id="element-137">
                  <span className="text-2xl md:text-3xl text-warm-white/70 font-serif" data-id="element-138">
                    $
                  </span>
                  <span className="text-6xl md:text-7xl lg:text-8xl font-serif text-gold-light font-bold leading-none" data-id="element-139">
                    7.39
                  </span>
                </div>

                <p className="text-warm-white/90 text-sm md:text-base italic" data-id="element-140">
                  Ahorras más del 96% si compras ahora — descuento por tiempo
                  limitado
                </p>
              </div>

              <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-141">
                SÍ, QUIERO RECUPERAR MI CUERPO Y MI ENERGÍA — ACCESO INMEDIATO
                POR $7.39
                <ArrowRightIcon className="w-5 h-5" data-id="element-142" />
              </motion.a>

              <p className="text-center text-charcoal/60 text-xs md:text-sm mt-4" data-id="element-143">
                🔒 Pago seguro • Acceso inmediato • Garantía de 60 días
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}